angular.module('tf.controllers')

    .controller('AccountUsersController', ['$scope','$state','FarmService','NotificationService', 'Session',
        function ($scope, $state, FarmService, NotificationService, Session){

            $scope.farm = {};
            $scope.selected = {};
            $scope.newMembers = {
                users : []
            };

            var hasUsersQuota = false;

            function checkUsersQuota(){
                $scope.isLoadingUsersQuota = true;
                FarmService.checkAvailableUsersQuota().then(function (res) {
                    $('.account-header-menu .account-header-buttons .account-header-button i.fa-spin').removeClass('fa-spin');
                    $scope.isLoadingUsersQuota = false;
                    hasUsersQuota = res.data;
                });
            }

            $scope.farmHasUsersQuota = function () {
                return hasUsersQuota;
            };

            $scope.goToUpgrade = function(){
                FarmService.goToUpgrade('To add more members contact', {initiator:'upgrade to add users - account users settings'});
            };

            if($state.current.name.indexOf('groups') > -1){
                $scope.activeTab = 1;
            } else {
                $scope.activeTab = 0;
            }

            function initFarm(){
                checkUsersQuota();
                $scope.loader({overlay : false});
                FarmService.getFarm().then(function(farm){
                    $scope.farm = farm;
                    FarmService.getMembers().then(function(members){
                        $scope.farm.members = members;
                        FarmService.getGroups().then(function(groups){
                            $scope.farm.groups = groups;
                            if(groups && groups.length) {
                                //$scope.selected.group = groups[0];
                            }
                            $scope.loader(false);
                        });
                    });
                });
            }

            $scope.getEmails = function pluckEmails(items){
                _.each(items, function(item){
                    console.log(item);

                });
            };




            $scope.addMembers = function(){
                NotificationService.confirm("Add Member", "Are you sure?", function() {
                    FarmService.addMembers($scope.shareEmails.emails, $scope.shareEmails.role).then(function () {
                        initFarm();
                    });
                });
            };

            $scope.saveMember = function(user){
                NotificationService.confirm("Update Member", "Are you sure?", function() {
                    FarmService.saveMember(user).then(function () {
                        initFarm();
                    });
                });
            };

            $scope.removeMember = function(user){
                NotificationService.confirm("Remove Member", "Are you sure that you want to remove "+user.local.first_name+" from this farm ?", function() {
                    FarmService.removeMember(user).then(function () {
                        initFarm();
                    });
                });
            };

            $scope.createGroup = function(name){
                if(name && name.length) {
                    NotificationService.confirm("Create Group", "Are you sure?", function () {
                        FarmService.createGroup({name: name}).then(function () {
                            initFarm();
                        });
                    });
                }
            };
            $scope.getGroupUsers = function(){

            };

            $scope.deleteGroup = function(group){
                NotificationService.confirm("Remove Group", "Are you sure that you want to remove "+group.name+" from this farm ?", function() {
                    FarmService.deleteGroup(group).then(function () {
                        initFarm();
                    });
                });
            };


            $scope.shareEmails = {
                emails : [],
                available : [],
                role : 'user'
            };



            initFarm();

            $scope.openMemberSettings= function(user){
                FarmService.openMemberSettings(user, $scope.farm,initFarm);
            };
            $scope.openAddMembersPopup = function(){
                FarmService.openAddMembersPopup($scope.farm,function(){
                    //$scope.activeTab = 0;
                    $state.go('app.account.users');
                    initFarm();
                });
            };
            $scope.openCreateGroupPopup = function(){
                FarmService.openCreateGroupPopup($scope.farm, function(){
                    //$scope.activeTab = 1;
                    $state.go('app.account.groups');
                    initFarm();
                });
            };
            $scope.manageGroup = function(group){
                FarmService.openManageGroupPopup(group, function(){
                    initFarm();
                });
            };

            $scope.getRole = function(user){
                var farm;
                if(user.farms) farm = user.farms.find(function(farm){return farm.farm === $scope.farm._id;});
                if(!farm && user.pending_invites){
                    farm = user.pending_invites.find(function(invite) {return invite.farm === $scope.farm._id;});
                }
                return farm && farm.role;
            };

        }]);
